import React from 'react';

import IUserSupervisor from '../interfaces/IUserSupervisor';
import List from '../components/List/List';

interface Props {
  userSupervisor: IUserSupervisor[];
  setUserSupervisor: React.Dispatch<React.SetStateAction<IUserSupervisor[]>>;
}

const UserSupervisor: React.FC<any> = ({
  userSupervisor,
  setUserSupervisor,
}: Props) => {
  const handleUpdateUserSupervisor = (
    seqUsuarioSubordinado: number,
    usuarioSubordinado: boolean
  ): void => {
    setUserSupervisor((records) => [
      ...records.map((record) => {
        if (record.seqUsuarioSubordinado === seqUsuarioSubordinado) {
          return {
            ...record,
            usuarioSubordinado: usuarioSubordinado ? 'S' : 'N',
          };
        }
        return record;
      }),
    ]);
  };

  return (
    <div
      className="table-responsive overflow-hidden"
      style={{
        borderRadius: '0.68rem',
        borderColor: 'transparent',
      }}
    >
      <div
        className="w-100 text-white p-2"
        style={{ backgroundColor: '#1A1A1A' }}
      >
        <span style={{ fontSize: '1.25rem', fontWeight: '600' }}>
          Usuários supervisionados pelo usuário
        </span>
      </div>
      <div
        className="rounded w-100 border-0 overflow-auto"
        style={{
          height: '19rem',
        }}
      >
        <List
          key="user-supervisor-list"
          data={userSupervisor}
          handleUpdateRegister={handleUpdateUserSupervisor}
          idField="seqUsuarioSubordinado"
          nameField="nomeSubordinado"
          checkedField="usuarioSubordinado"
        />
      </div>
    </div>
  );
};

export default UserSupervisor;
